import PubSub from "pubsub-js";
import { useEffect } from "react";

import type { PubSubSharedActions } from "./pubsub-actions.ts";

export const useSubscription = <T = unknown>(
  event: PubSubSharedActions | string,
  subscriber: PubSubJS.SubscriptionListener<T>,
  deps: readonly unknown[] = [],
) => {
  useEffect(() => {
    const token = PubSub.subscribe(event, subscriber);
    return () => {
      PubSub.unsubscribe(token);
    };
    // can't do static analysis of destructured array
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event, subscriber, ...deps]);
};
